import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";
import { config } from "_config";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  padding: 36px 32px 36px;
  margin-bottom: 33px;
  background: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  @media (max-width: ${breakpoints.mobileM}) {
    padding: 24px 12px 12px;
  }
`;
const Title = styled.h1`
  width: 100%;
  text-align: center;
  margin: 0;
  margin-bottom: 10px;
  font-family: "Montserrat";
  font-size: 16px;
  line-height: 16px;
  color: #7b848d;
`;
const SubTitle = styled.h2`
  width: 100%;
  margin: 0;
  margin-bottom: 30px;
  text-align: center;
  font-family: "Montserrat";
  font-size: 12px;
  line-height: 12px;
  color: #7b848d;
`;
const Row = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-top: 1px solid #ecedf1;
  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
  ${({ index }) =>
    index % 2 !== 0 &&
    css`
      background-color: #fafaff;
    `}
`;
const Cell = styled.div`
  padding: 6px 0;
  font-size: 12px;
  color: #394149;
`;
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 14px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #cd4444;

  @media (max-width: ${breakpoints.mobileM}) {
    text-align: center;
    gap: 8px;
  }
`;
const HelpLink = styled.a`
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #cd4444;
  text-decoration: none;
  &:hover {
    color: #cd4444;
    text-decoration: none;
  }
`;
const EmptyMessage = styled.div`
  color: #7b848d;
  text-align: center;
  font-weight: bold;
`;

function Classification({ index, goods, goodsCategory, goodsServiceDetail, description }) {
  return (
    <Row index={index}>
      <Cell>
        <b>{goods ? "Good" : "Service"}</b>
      </Cell>
      <Cell>{goodsCategory}</Cell>
      <Cell>{description}</Cell>
      <Cell>{goodsServiceDetail}</Cell>
    </Row>
  );
}

Classification.propTypes = {
  index: PropTypes.number,
  goods: PropTypes.bool,
  goodsCategory: PropTypes.string,
  goodsServiceDetail: PropTypes.string,
  description: PropTypes.string,
};

function TrademarkClassificationsMobile({ classes }) {
  return (
    <Container>
      {classes ? (
        <>
          <Title>Trademark Classifications</Title>
          <SubTitle>Classification information</SubTitle>
          <div>
            {classes.map((classification, idx) => (
              <Classification key={idx} index={idx} {...classification} />
            ))}
          </div>
          <InfoRow>
            Need to update or delete the class?
            <HelpLink href={`${config.trademarkUiUrl}/contact`}>Contact Customer Service</HelpLink>
          </InfoRow>
        </>
      ) : (
        <EmptyMessage>No Trademark Classifications info for this order</EmptyMessage>
      )}
    </Container>
  );
}

TrademarkClassificationsMobile.propTypes = {
  classes: PropTypes.arrayOf(PropTypes.object),
};

export default TrademarkClassificationsMobile;
